export const LIST_DOCUMENT_CLASSIFICATION_REQUEST = 'LIST_DOCUMENT_CLASSIFICATION_REQUEST'
export const LIST_DOCUMENT_CLASSIFICATION_SUCCESS = 'LIST_DOCUMENT_CLASSIFICATION_SUCCESS'
export const LIST_DOCUMENT_CLASSIFICATION_FAIL = 'LIST_DOCUMENT_CLASSIFICATION_FAIL'

export const CREATE_DOCUMENT_CLASSIFICATION_REQUEST = 'CREATE_DOCUMENT_CLASSIFICATION_REQUEST'
export const CREATE_DOCUMENT_CLASSIFICATION_SUCCESS = 'CREATE_DOCUMENT_CLASSIFICATION_SUCCESS'
export const CREATE_DOCUMENT_CLASSIFICATION_FAIL = 'CREATE_DOCUMENT_CLASSIFICATION_FAIL'

export const DETAIL_DOCUMENT_CLASSIFICATION_REQUEST = 'DETAIL_DOCUMENT_CLASSIFICATION_REQUEST'
export const DETAIL_DOCUMENT_CLASSIFICATION_SUCCESS = 'DETAIL_DOCUMENT_CLASSIFICATION_SUCCESS'
export const DETAIL_DOCUMENT_CLASSIFICATION_FAIL = 'DETAIL_DOCUMENT_CLASSIFICATION_FAIL'

export const UPDATE_DOCUMENT_CLASSIFICATION_REQUEST = 'UPDATE_DOCUMENT_CLASSIFICATION_REQUEST'
export const UPDATE_DOCUMENT_CLASSIFICATION_SUCCESS = 'UPDATE_DOCUMENT_CLASSIFICATION_SUCCESS'
export const UPDATE_DOCUMENT_CLASSIFICATION_FAIL = 'UPDATE_DOCUMENT_CLASSIFICATION_FAIL'

export const DELETE_DOCUMENT_CLASSIFICATION_REQUEST = 'DELETE_DOCUMENT_CLASSIFICATION_REQUEST'
export const DELETE_DOCUMENT_CLASSIFICATION_SUCCESS = 'DELETE_DOCUMENT_CLASSIFICATION_SUCCESS'
export const DELETE_DOCUMENT_CLASSIFICATION_FAIL = 'DELETE_DOCUMENT_CLASSIFICATION_FAIL'

export const LIST_DOCUMENT_CLASSIFICATION_SUMMARY_REQUEST = 'LIST_DOCUMENT_CLASSIFICATION_SUMMARY_REQUEST'
export const LIST_DOCUMENT_CLASSIFICATION_SUMMARY_SUCCESS = 'LIST_DOCUMENT_CLASSIFICATION_SUMMARY_SUCCESS'
export const LIST_DOCUMENT_CLASSIFICATION_SUMMARY_FAIL = 'LIST_DOCUMENT_CLASSIFICATION_SUMMARY_FAIL'
